import { alpha } from "@material-ui/core/styles";
export var createMuiBackdropOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            backgroundColor: alpha(palette.common.black, 0.72),
        },
    });
};
//# sourceMappingURL=MuiBackdrop.js.map